// Booking + contact CTA helpers.
export const BOOK_REASONS = [
  "Complex / Sensitive ER Case",
  "Workplace Investigation",
  "People Risk",
  "ER Framework / Capability",
  "Fractional ER Support",
  "Other Employee Relations Matter",
];

// Map a service "interest" to the booking dropdown reason.
export const INTEREST_TO_REASON = {
  "sensitive-case": "Complex / Sensitive ER Case",
  "er-clarity": "Other Employee Relations Matter",
  "investigation": "Workplace Investigation",
  "people-risk": "People Risk",
  "er-framework": "ER Framework / Capability",
  "er-diagnostic": "ER Framework / Capability",
  "fractional": "Fractional ER Support",
  "general": "Other Employee Relations Matter",
};

export function bookHref(reason) {
  return reason ? `/book-consultation?reason=${encodeURIComponent(reason)}` : "/book-consultation";
}

export function bookHrefForInterest(interest) {
  return bookHref(INTEREST_TO_REASON[interest]);
}

// Contact form (secondary path — general enquiries)
export const CONTACT_AREAS = [
  "Sensitive Case Advisory",
  "Workplace Investigation",
  "People Risk Advisory",
  "ER Capability Diagnostic",
  "Scalable ER Function Build",
  "Fractional ER & People Risk Partner",
  "General Enquiry",
];
